import { isAxiosError } from 'axios';

export interface ApiErrorResponse {
	error_details?: {
		error?: string;
	};
	error?: string;
}

/** BE duplicate-name contract (saas-water-ai-pipe-deterioration PR #260): HTTP 400 with a stable English message containing "already exists" in error or error_details.error. No dedicated error code yet. */
export function getApiErrorMessage(error: unknown, fallback: string): string {
	if (!isAxiosError<ApiErrorResponse>(error)) {
		return fallback;
	}

	return error.response?.data?.error_details?.error || error.response?.data?.error || fallback;
}

export function isDuplicateNameError(error: unknown): boolean {
	if (!isAxiosError<ApiErrorResponse>(error)) {
		return false;
	}

	const message = getApiErrorMessage(error, '').toLowerCase();
	return error.response?.status === 400 && message.includes('already exists');
}
